.BrandEditor {
	font-size: 20px;
}